import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ITableCertificationParams {
  // table vizportal id.
  id: string;
  isCertified: boolean;
  certificationNote: string;
}

export class SetTableCertificationRequest extends Request<ITableCertificationParams, IResult> {
  constructor(params: ITableCertificationParams) {
    super('setTableCertification', params);
  }
}
